import { render, staticRenderFns } from "./index.vue?vue&type=template&id=327c9f6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=327c9f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c9f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327c9f6c')) {
      api.createRecord('327c9f6c', component.options)
    } else {
      api.reload('327c9f6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=327c9f6c&scoped=true&", function () {
      api.rerender('327c9f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_payment-transfer/index.vue"
export default component.exports